import styled from '@emotion/styled';
import { Backdrop } from '@mui/material';

import { theme } from '@/theme';

export const StyledWrapper = styled.span`
    display: flex;
    height: 100%;
    justify-content: center;
    align-items: center;
`;

export const StyledBackdrop = styled(Backdrop)<{ shadow: 'default' | 'lower' }>`
    z-index: 9;
    color: ${theme.palette.common.white};
    background-color: ${({ shadow }) => (shadow === 'lower' ? 'rgba(0, 0, 0, 0.2)' : 'rgba(0, 0, 0, 0.5)')};
`;
